import { HubConnection, IRetryPolicy } from "@microsoft/signalr";

export class ReconnectRetryPolicy implements IRetryPolicy {
  nextRetryDelayInMilliseconds(): number | null {
    return 3000;
  }
}

export function stopHubConnection(connection: HubConnection) {
  if (connection && connection["_connectionState"] == "Connected") {
    connection.stop().then();
  }
}
